// Copyright (c) 2026 aiApas LLC. All Rights Reserved.
// GuardRok — Proprietary and Confidential. Patent Pending.
// Unauthorized use or distribution is prohibited.

import { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Cookie } from "lucide-react"

const STORAGE_KEY = "gr_cookie_consent"

export default function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setTimeout(() => setVisible(true), 1200)
    }
  }, [])

  function accept() {
    localStorage.setItem(STORAGE_KEY, "accepted")
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div style={{
      position: "fixed", bottom: 24, left: "50%", transform: "translateX(-50%)",
      zIndex: 9999, width: "min(620px, calc(100vw - 32px))",
      background: "#0f172a", border: "1px solid #1e293b", borderRadius: 14,
      padding: "16px 20px", display: "flex", alignItems: "center", gap: 16,
      boxShadow: "0 8px 40px rgba(0,0,0,0.6)",
    }}>
      <div style={{ width: 36, height: 36, background: "#1e293b", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        <Cookie size={18} color="#94a3b8" />
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, color: "#e2e8f0", fontWeight: 600, marginBottom: 3 }}>We use only essential cookies</div>
        <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.5 }}>
          Session cookies required for login — no tracking, no ads.{" "}
          <Link to="/cookies" style={{ color: "#94a3b8", textDecoration: "underline" }}>Cookie Policy</Link>
        </div>
      </div>
      <button onClick={accept} style={{
        background: "#E63946", color: "#fff", border: "none", borderRadius: 8,
        fontSize: 13, fontWeight: 700, padding: "8px 18px", cursor: "pointer", flexShrink: 0,
      }}>
        Got it
      </button>
    </div>
  )
}
